import React, { FC } from 'react'
import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

import userInfoStore from '@src/stores'
import { ConfigProvider } from 'zn-admin-ui'
import { setThemeColor } from 'zn-common'

import Login from '../pages/login'
import AppBar from '../components/app-bar'

import getRoutes from './lazy-load'
import '../pages/home/img/bannerBg.png'
import '../pages/home/img/program.png'
import '../styles/toastui-reset.less'

const BaseApp = ({ children }) => {
  setThemeColor('rgba(255,109,109,1)')
  return (
    <ConfigProvider prefixCls="znd">
      <Router>
        <Switch>
          <Route exact key="login" path="/login" component={Login} />
          <Route key="layout" path="/">
            {window.location.hash === '#/' || (!window.location.hash) ? <Redirect to="/home"></Redirect> : null}
            <AppBar />
            <div>{children}</div>
          </Route>
        </Switch>
      </Router>
    </ConfigProvider>
  )
}

const  App: FC<any> = ({ routes }) => {
  return (
    <div className='admin-m1'>
      <BaseApp>
        <Router>
          <Switch>
            {getRoutes(routes).map(r => (
              <Route
                exact
                key={r.path}
                path={r.path}
                render={props => <r.component {...props} route={r} />}
              />
            ))}
          </Switch>
        </Router>
      </BaseApp>
    </div>
  )
}

export default userInfoStore.withProvider(App)

